<template>
	<div v-if="show">
		<component :is="componentType" data-testid="lazyload-component" />
	</div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { getAuthoredContent } from '@/util/getAuthoredContent';
import ScheduleATour from '../schedule-a-tour/scheduleATour.vue';

export interface LazyLoadContent {
	selector?: string;
	event?: string;
}

const show = ref(false);
const selector = ref('');
const event = ref('');
const componentType = ref(ScheduleATour);

onMounted(() => {
	const authoredContent = getAuthoredContent<LazyLoadContent>('aemuiLazyloadComponentScript');
	selector.value = authoredContent?.selector || '.memberships-panel';
	event.value = authoredContent.event || 'show.bs.offcanvas';
	const element = document.querySelector<HTMLElement>(selector.value);
	element?.addEventListener(event.value, () => {
		show.value = true;
	});
});

defineExpose({
	show,
	selector,
	event
});
</script>
